import { useState } from "react";
import styles from "./SizeChart.module.scss";
import { TertiaryButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import { RulerOutlined as Ruler24PxOutlinedIcon } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/RulerOutlined";
import { Modal } from "@JohnLewisPartnership/jl-design-system/dist/components/modal/Modal";
import { sendEvent } from "@JohnLewisPartnership/experiments-utils";

import { dispatchAnalyticsEvent } from "@/utils";

type Props = {
  sizeGuideContent: string;
  handleRecordImpression: (impressionStatus: boolean) => void;
};

export const SizeChartUI = ({
  sizeGuideContent,
  handleRecordImpression,
}: Props) => {
  const [isModalOpen, setModalOpen] = useState(false);

  const openModal = async () => {
    setModalOpen(true);
    dispatchAnalyticsForSizeChart();
    handleRecordImpression(true);
  };

  const dispatchAnalyticsForSizeChart = async () => {
    sendEvent("product-page-size-chart-click");
    dispatchAnalyticsEvent(
      "pdp.modalOpened",
      { type: "size and delivery" },
      {},
    );
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const sizeChartText = "Size chart";

  return (
    <>
      <TertiaryButton
        small
        onClick={openModal}
        id="size-guide-button"
        data-cy="size-guide-button"
        data-testid="size-guide-button"
        data-component="SizeChart"
      >
        <div className={styles.sizeCharts}>
          <Ruler24PxOutlinedIcon size="medium" />
          <span className={styles.sizeChartLabel}>{sizeChartText}</span>
        </div>
      </TertiaryButton>
      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        width="medium"
        title={sizeChartText}
        footer={false}
      >
        <div
          data-testid="sizing-guide-content"
          className={styles.sizingGuideContainer}
          dangerouslySetInnerHTML={{ __html: sizeGuideContent }}
        />
      </Modal>
    </>
  );
};
